/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MitarbeiterAttributDto } from '../../models/mitarbeiter-attribut-dto';

export interface GetAllMitarbeiterAttribute$Json$Params {
}

export function getAllMitarbeiterAttribute$Json(http: HttpClient, rootUrl: string, params?: GetAllMitarbeiterAttribute$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MitarbeiterAttributDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllMitarbeiterAttribute$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MitarbeiterAttributDto>>;
    })
  );
}

getAllMitarbeiterAttribute$Json.PATH = '/v1/mitarbeiter-attribute';
